import script from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"
export * from "./cryptoWithdraw.vue?vue&type=script&setup=true&lang=ts"

import "./cryptoWithdraw.vue?vue&type=style&index=0&id=ecfa32d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecfa32d8"]])

export default __exports__